// extracted by mini-css-extract-plugin
export default {"nav_bloc":"ItemSidenav_nav_bloc__eXbbt","content_container":"ItemSidenav_content_container__st-HC","name":"ItemSidenav_name__TIc5B"};